export default __webpack_public_path__ + "/dist/images/Youtube.a76d42c26d84f63b34d7bb2466446cf3.svg";